import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../firebase";

export default function AdminLogin({ onLogin }) {
  async function handleGoogleLogin() {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const email  = result.user.email;
      const ALLOWED = process.env.REACT_APP_ADMIN_EMAIL;
      if (email !== ALLOWED) {
        await auth.signOut();
        alert(`Access denied. This admin is only accessible to the site owner.`);
        return;
      }
      onLogin(result.user);
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "#fafafa",
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{
        background: "#fff", border: "1px solid #eee", borderRadius: 8,
        padding: "48px 40px", textAlign: "center", maxWidth: 360, width: "100%",
      }}>
        <div style={{
          fontSize: 20, fontWeight: 900, letterSpacing: "-.02em", marginBottom: 6,
        }}>
          SNHW <span style={{ color: "#ff2d9b" }}>Admin</span>
        </div>
        <p style={{ fontSize: 12, color: "#999", marginBottom: 32, letterSpacing: ".06em", textTransform: "uppercase" }}>
          Songs No Human Wrote
        </p>
        <button
          onClick={handleGoogleLogin}
          style={{
            display: "flex", alignItems: "center", justifyContent: "center",
            gap: 10, width: "100%", padding: "12px 20px",
            border: "1.5px solid #eee", borderRadius: 4, background: "#fff",
            cursor: "pointer", fontSize: 13, fontWeight: 600,
            fontFamily: "'DM Sans', sans-serif", transition: "border-color .15s",
          }}
          onMouseEnter={e => e.currentTarget.style.borderColor = "#ccc"}
          onMouseLeave={e => e.currentTarget.style.borderColor = "#eee"}
        >
          <svg width="18" height="18" viewBox="0 0 48 48">
            <path fill="#4285F4" d="M43.6 20H24v8h11.3C33.6 33.1 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.8 2.9l5.7-5.7C33.8 6.5 29.2 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11 0 19.6-7.9 19.6-20 0-1.3-.1-2.7-.4-4z"/>
            <path fill="#34A853" d="M6.3 14.7l6.6 4.8C14.5 16.1 19 13 24 13c3 0 5.7 1.1 7.8 2.9l5.7-5.7C33.8 6.5 29.2 4 24 4c-7.7 0-14.3 4.5-17.7 10.7z"/>
            <path fill="#FBBC05" d="M24 44c5.2 0 9.8-1.7 13.4-4.7l-6.2-5.2C29.3 35.5 26.8 36 24 36c-5.2 0-9.6-2.9-11.3-7.1l-6.5 5C9.7 39.5 16.3 44 24 44z"/>
            <path fill="#EA4335" d="M43.6 20H24v8h11.3c-.8 2.3-2.3 4.2-4.3 5.5l6.2 5.2C40.9 35.1 44 30 44 24c0-1.3-.1-2.7-.4-4z"/>
          </svg>
          Sign in with Google
        </button>
        <p style={{ fontSize: 10, color: "#ccc", marginTop: 20, letterSpacing: ".04em" }}>
          Restricted to authorized users only
        </p>
      </div>
    </div>
  );
}